import { Box, Flex } from 'rebass';
import { UAContext } from '@quentin-sommer/react-useragent';
import {
  FaCamera as ImageIcon,
  FaMicrophone as AudioIcon,
  FaImages as LibraryIcon,
} from 'react-icons/fa';
import PropTypes from 'prop-types';
import React, { useState, useContext, useCallback } from 'react';

import { DottedDivider } from 'app/styled';
// import RecordChatButton from 'chats/record-chat-button';
import BigSelfieButton from './big-selfie-button';

import { Button, Label } from './styled';

import ButtonLabelWrap from './button-label-wrap';
import Modal from '../../app/modal/v3';
import NewStoryWithMediumButton from './medium-button';
import TextIcon from '../../app/icons/add-text';
import NewStoryMediumForm from './form';
import NewMediaPopupMoreButton from './more-button';
import NewMultipleMedia from './multiple-media/index';
import LoadingIcon from 'app/inline-loading/index';
import RecordAudio from 'stories/tell-a-story/RecordAudio';

const NewMediaPopup = ({
  onClose,
  title,
  onSubmitText,
  onSubmitMedia,
  onSubmitExternalMedium,
  dividerText,
  // onRecordChat,
}) => {
  const [currentForm, setCurrentForm] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [initialFiles, setInitialFiles] = useState(false);
  const maxWidth = currentForm ? 620 : 414;
  const {
    uaResults: { android },
  } = useContext(UAContext);

  const handleChange = useCallback(
    (e, transcribe = false) => {
      setIsLoading(true)
      if (android) return setInitialFiles(e.target.files);
      return onSubmitMedia(e.target.files, transcribe);
    },
    [android, onSubmitMedia]
  );

  if (initialFiles)
    return (
      <NewMultipleMedia
        onClose={onClose}
        initialFiles={initialFiles}
        maxWidth={maxWidth}
        onSubmitMedia={files => onSubmitMedia(files)}
      />
    );

  const submitting = false;

  return (
    <Modal
      close={{ onClose }}
      maxWidth={maxWidth}
      title={title}
      closeOnOutsideClick={false}
      aboveTooltip
    >
      {isLoading && <Box sx={{
        position: 'absolute',
        height: '100%',
        width: '100%',
        bg: 'rgba(0,0,0, 0.15)',
        padding: '25%',
        zIndex: 1
      }}>
        <LoadingIcon />
      </Box>}
      <Box style={{ background: 'white', display: 'grid' }}>
        <NewStoryMediumForm
          onSubmitText={onSubmitText}
          onSubmitExternalMedium={onSubmitExternalMedium}
          currentForm={currentForm}
          setCurrentForm={setCurrentForm}
        />
        {!currentForm && (
          <Box pt={0} p={3}>
            <Flex justifyContent="space-around" m="auto" mb={3}>
              <BigSelfieButton handleChange={handleChange} />
            </Flex>
            <DottedDivider>{dividerText}</DottedDivider>
            <Flex alignItems="center" justifyContent="center">
              <ButtonLabelWrap label="Text">
                <Button
                  onClick={() => {
                    setCurrentForm('textForm');
                  }}
                  disabled={submitting}
                >
                  <TextIcon />
                </Button>
              </ButtonLabelWrap>
              <NewStoryWithMediumButton
                type="any"
                disabled={submitting}
                handleChange={handleChange}
                label="Library"
              >
                <LibraryIcon />
              </NewStoryWithMediumButton>
              {/* <NewStoryWithMediumButton
                type="any"
                disabled={submitting}
                handleChange={handleChange}
                label="Camera"
                capture
              >
                <ImageIcon />
              </NewStoryWithMediumButton> */}
              <RecordAudio justIcon label="Audio" onSubmitMedia={onSubmitMedia} />
              <NewMediaPopupMoreButton onLinkClick={setCurrentForm} disabled={submitting} />
            </Flex>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

NewMediaPopup.defaultProps = {
  title: 'Add Media',
  dividerText: 'other types',
  pagePosition: null,
};

NewMediaPopup.propTypes = {
  title: PropTypes.string,
  dividerText: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onRecordChat: PropTypes.func.isRequired,
  onSubmitText: PropTypes.func.isRequired,
  onSubmitMedia: PropTypes.func.isRequired,
  onSubmitExternalMedium: PropTypes.func.isRequired,
  pagePosition: PropTypes.number,
};

export default NewMediaPopup;
